import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { fetchReset } from '../../actions/fetch.actions';
import {
  ADMIN_ORGANIZATIONS_PATHS,
  ADMIN_PATH,
  ADMIN_SCHOOLS_PATHS,
  ADMIN_TAB_PATHS
} from '../../constants/paths.constants';
import { TOAST_TYPES } from '../../constants/settings.constants';
import { ADMIN_SCHOOL_AGODI_BRANCHES_RESOURCE } from '../../resources/admin/admin.school.agodi.branches.resource';
import { ADMIN_SCHOOL_BRANCHES_RESOURCE } from '../../resources/admin/admin.school.branches.resource';
import { ADMIN_SCHOOL_COMMUNITY_RESOURCE } from '../../resources/admin/admin.school.community.resource';
import { ADMIN_SCHOOL_MANAGEMENT_RESOURCE } from '../../resources/admin/admin.school.management.resource';
import { ADMIN_SCHOOL_SCHOOLS_RESOURCE } from '../../resources/admin/admin.school.schools.resource';
import { fetchErrorSelector } from '../../selectors/fetch.selectors';
import toastService from '../../services/toasts.service';

const MESSAGE_BY_RESOURCE = {
  [ADMIN_SCHOOL_MANAGEMENT_RESOURCE.key]:
    'Kan de schoolbesturen niet laden. Je bent een niveau hoger in de hiërarchie geplaatst',
  [ADMIN_SCHOOL_COMMUNITY_RESOURCE.key]:
    'Kan de schoolgemeenschappen niet laden. Je bent een niveau hoger in de hiërarchie geplaatst',
  [ADMIN_SCHOOL_SCHOOLS_RESOURCE.key]: 'Kan de scholen niet laden. Je bent een niveau hoger in de hiërarchie geplaatst',
  [ADMIN_SCHOOL_BRANCHES_RESOURCE.key]:
    'Kan de vestigingen niet laden. Je bent een niveau hoger in de hiërarchie geplaatst',
  [ADMIN_SCHOOL_AGODI_BRANCHES_RESOURCE.key]:
    'Kan de agodi vestigingen niet laden. Je bent een niveau hoger in de hiërarchie geplaatst'
};

const PATH_BY_RESOURCE = {
  [ADMIN_SCHOOL_MANAGEMENT_RESOURCE.key]: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}`,
  [ADMIN_SCHOOL_COMMUNITY_RESOURCE.key]: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.MANAGEMENT.path}`,
  [ADMIN_SCHOOL_SCHOOLS_RESOURCE.key]: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.COMMUNITIES.path}`,
  [ADMIN_SCHOOL_BRANCHES_RESOURCE.key]: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.SCHOOLS.path}`,
  [ADMIN_SCHOOL_AGODI_BRANCHES_RESOURCE.key]: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.BRANCHES.path}`
};

export const useLevelLoadError = (resourceKey) => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const error = useSelector((state) => fetchErrorSelector(state, { resource: { key: resourceKey } }));
  const hasError = !!error;

  useEffect(() => {
    if (hasError) {
      toastService.showToast(TOAST_TYPES.ERROR, MESSAGE_BY_RESOURCE[resourceKey]);
      navigate(generatePath(PATH_BY_RESOURCE[resourceKey], params));
      dispatch(fetchReset({ key: resourceKey }));
    }
  }, [navigate, dispatch, params, resourceKey, hasError]);
};
